<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="right-side-bar-main-sec deposit_section deposit_module_wrapper">
            <div class="deposit-withdraw-sec">
                <div class="go-to-back-sec wallet_back_btn">
                    <a @click="$router.go(-1)">
                        {{ $t('back', 'Back') }}
                    </a>
                </div>
                <div class="dw_bg_cl">
                    <div class="type_of_deposit_parent">
                        <h2>Choose a payment method</h2>
                        <div class="description_card_body payment_type_tabs_cl">
                            <div class="row">
                                <div class="col-12">
                                    <div class="deposit_tabs_cl">
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li v-for="(method, index) in paymentMethods" :key="index" class="nav-item" role="presentation">
                                                <button class="nav-link" :class="{ active: activeTab === index }, paymentBonus?.[method?.[0]?.method_id] ? 'paymentBonus' : ''" @click="choosePaymentMethod(method, index)"
                                                data-bs-toggle="tab" data-bs-target="#tab" id="tabId" role="tab" 
                                                type="button" aria-controls="tab" :aria-selected="activeTab === index">
                                                <div class="get-bonus-sec" v-if="paymentBonus?.[method?.[0]?.method_id]">Get {{ paymentBonus?.[method?.[0]?.method_id] }}% Bonus</div>
                                                    <figure class="deposit_fgr">
                                                        <figcaption>{{ index }}</figcaption>
                                                        <img loading="lazy" :src="methodIcons[index]" />
                                                    </figure>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <span v-if="selectPaymentAccount?.method == 'bank' && !isPaymentGateway">You can add through a bank transfer</span>
                            </div>
                        </div>
                        <div class="description-card-body payment_type_tabs_content_cl">
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="tab" role="tabpanel" aria-labelledby="tabId">
                                    <div class="withdraw-sec add-account-sec" v-if="isPaymentGateway &&  selectedPaymentMethod?.[0]?.method != 'social'">
                                        <div class="hide-input-sec payment-gateway-sec">
                                            <span>
                                                Pay using our payemnt gateway
                                            </span>
                                            <span class="matka-but-dflex pg-btn">
                                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="depo-lft-container imps_deposit_sec imps_tabs_content" v-if="selectedPaymentMethod && !isPaymentGateway && selectedPaymentMethod?.[0]?.method != 'social'">
                                        <div class="account_data_parent_cl">
                                            <div class="about-text">
                                                <!-- <h5 class="card_title_cl">{{ method.name }}</h5> -->
                                            </div>
                                            <div class="account-data add_acc_data_list" :class="{ 'selected-card' : selectPaymentAccount?.master_account_id === bank?.master_account_id }"
                                                v-for="bank in selectedPaymentMethod" :key="bank.agent_bank_id" @click="selectPaymentMethodAccount(bank)">
                                                <p v-if="bank?.bank_name" class="card-text">
                                                    <label>
                                                        <b>{{ $t('bank-name', 'Bank Name') }}</b> :
                                                        <span>{{ bank?.bank_name }}</span>
                                                    </label>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('bank-name', 'Bank Name'), bank?.bank_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span></div>
                                                    </button>
                                                </p>
                                                <p class="card-text" v-if="bank?.account_number">
                                                    <label>
                                                        <b>{{ $t('account-number', 'Account Number') }}</b> :
                                                        <span>{{ bank?.account_number }}</span>
                                                    </label>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('account-number', 'Account Number'), bank.account_number,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span></div>
                                                    </button>
                                                </p>
                                                <p class="card-text">
                                                    <label>
                                                        <b>{{ bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}</b> :
                                                        <span>{{ bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id) }}</span>
                                                    </label>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData(bank.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), bank.account_number ? bank.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span></div>
                                                    </button>
                                                </p>
                                                <p class="card-text">
                                                    <label>
                                                        <b>{{ $t('account-holder-name', 'Account holder’s name') }}</b> :
                                                        <span>{{ bank?.account_holder_name }}</span>
                                                    </label>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData($t('account-holder-name', 'Account holder’s name'), bank?.account_holder_name,index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span></div>
                                                    </button>
                                                </p>
                                                <p class="card-text" v-if="bank?.crypto_wallet_id">
                                                    <label>
                                                        <b>Deposit Amount</b> :
                                                        <span>
                                                            {{ formatNumberToIntegerOrTwoDigitDecimal(depositAmount/bank?.multiplier_value) }} {{ bank?.method_name}}
                                                            <span>( at x{{ Number(bank?.multiplier_value) }} )</span>
                                                        </span>
                                                    </label>
                                                    <button class="btn txt_copy_cl" @click="copyPaymentData('Deposit Amount', (depositAmount/bank?.multiplier_value),index)">
                                                        <i class="fa-solid fa-copy"></i>
                                                        <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied-successfully', ' Copied Successfully') }}!</span></div>
                                                    </button>
                                                </p>
                                                <div class="qrCode-pic" v-if="bank?.qr_code">
                                                    <div class="click-qr-preview-img">
                                                        <ul>
                                                            <li>
                                                                <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" 
                                                                    @click="currentImgLink = bank?.qr_code">
                                                                    <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button class="click-qr-icons" data-bs-toggle="modal" data-bs-target="#qrShareModal" 
                                                                    @click="currentImgLink = bank?.qr_code">
                                                                    <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button class="click-qr-icons" 
                                                                    @click="downloadQrImg(bank?.qr_code, bank?.account_holder_name)">
                                                                    <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <figure v-if="bank?.qr_code">
                                                        <img loading="lazy" :src="bank?.qr_code" alt="QR-Code">
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="utr_proof_cl">
                                            <div class="form-group utr_file_input_grp" v-if="!previewImageUtr">
                                                <label for="proofOfDeposit220225">{{ $t('upload-your-payment-proof', 'Upload Your Payment Proof') }} 
                                                    <small style="color: red;">*</small></label>
                                                <input type="file" ref="fileRef" class="form-control"  @click="onFilePickerOpen" @change="fileUpdateFunc($event)" accept=".png, .jpg, .jpeg, .webp" />
                                            <div v-if="init.transaction_image_url && !uploadedImage" class="error_cl" for="transactionId">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}. </div>
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="previewImageUtr">
                                            <label class="payment_slip_title">{{ $t('payment-slip', 'Payment Slip') }}</label>
                                            <div class="fileList deposit-previewImage">
                                                <img loading="lazy" class="fileList-img" :src="previewImageUtr" alt="file-list"/>
                                                <button class="add-utr-again" @click="clearPaymentSlip()">
                                                    &#10006;
                                                </button>
                                                <div class="fileList-loader" v-if="utrLoader">
                                                    <div class="loader">
                                                        <div class="sk-fading-circle">
                                                            <div class="sk-circle1 sk-circle"></div>
                                                            <div class="sk-circle2 sk-circle"></div>
                                                            <div class="sk-circle3 sk-circle"></div>
                                                            <div class="sk-circle4 sk-circle"></div>
                                                            <div class="sk-circle5 sk-circle"></div>
                                                            <div class="sk-circle6 sk-circle"></div>
                                                            <div class="sk-circle7 sk-circle"></div>
                                                            <div class="sk-circle8 sk-circle"></div>
                                                            <div class="sk-circle9 sk-circle"></div>
                                                            <div class="sk-circle10 sk-circle"></div>
                                                            <div class="sk-circle11 sk-circle"></div>
                                                            <div class="sk-circle12 sk-circle"></div>
                                                        </div>
                                                    </div>
                                                    <span class="count_down_timer">{{ timerValue }}</span>
                                                </div>
                                            </div>
                                      <div v-if="init.transaction_image_url && !uploadedImage" class="error_cl" for="transactionId">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}. </div>
                                            <div class="paymentProofFileUploadStatus"v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>
                                        </div>

                                        <div class="form-group amount_deposit_input">
                                            <label class="transection_title" for="transactionId">{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }}
                                                <small style="color: red;" v-if="selectPaymentAccount?.method != 'wallet'">*</small>
                                            </label>
                                            <div class="utr_loader_input_box">
                                                <input type="tel" :maxlength="selectPaymentAccount?.method != 'wallet' ? 15 : 128" class="form-control utr_input_cl" v-model="manual_utr" @input="validateUTR(), has_edited_utr = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" />
                                            </div>
                                            <div id="transactionId-error" v-if="selectPaymentAccount?.method != 'wallet' && init.utr && !manual_utr?.length" class="error_cl" for="transactionId">{{$t('utr-number-is-required','UTR Number is Required')}}</div>
                                            <div id="transactionId-error" v-else-if="selectPaymentAccount?.method != 'wallet' && init.utr && manual_utr?.length < 10" class="error_cl" for="transactionId">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</div>
                                        </div>

                                        <div class="form-group amount_deposit_input">
                                            <label class="amount_cmn_title" for="exampleFormControlInput1">{{ $t('amount', 'Amount') }} <small style="color: red;">*</small></label>
                                            <input type="number" class="form-control" v-model="depositAmount" readonly />
                                        </div>

                                        <input type="hidden" id="accountId" value="220225" />
                                        <div class="custom-control custom_checkbox_cl">
                                            <input type="checkbox"  class="form-check-input custom-control-input" v-model="termsAgreed" />
                                            <label class="custom-control-label" for="termsCheck220225">{{ $t('i-have-read-and-agree-with', 'I have read and agree with') }}
                                                <a href="#termsAndCondition" data-bs-toggle="modal" class="terms_condition_cl">
                                                    {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}.
                                                </a>
                                            </label>
                                        </div>
                                        <div class="submit_form_cl_div">
                                            <button type="button" class="withdrawBtn submit_form_cl" @click="walletDepositSubmitBtn()" :class="{ 'btn-loading': loading }">
                                                {{ $t('submit', 'Submit') }} 
                                                <span><b></b><b></b><b></b></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="deposit-main-body">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="depo-rgt-container deposit_amount_table_cl">
                                    <div class="withdrawal_rgt_container">
                                        <div class="table-responsive">
                                            <WalletHistory ref="wallet_history"></WalletHistory>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- term conditation modal pop up-->
    <div class="modal fade" id="termsAndCondition" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content wallet_edit_stake_modal">
                <div class="modal-header modal_cmn_header">
                    <h5 class="modal-title">
                        {{ $t('the-terms-of-payment-and-withdrawal-policy', 'The terms of payment and withdrawal policy') }}
                    </h5>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close" data-original-title="" title="">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="term_condiation_body_wrapper p-0">
                        <p>
                        {{ $t('limits-the-maximum-deposit-limit-on-your-account', 'Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks.') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            {{ $t('please-contact-support', 'Please contact') }} 
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary " style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                            {{ $t('for-further-information', 'for further information') }}.
                        </span>
                        </p>

                        <p>
                        {{ $t('security-please-note-you-may-be-asked-to-supply', 'Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out more, please click here.') }}
                        </p>

                        <p>
                        {{ $t('withdrawals-withdrawals-will-be-directed-to-the-same-source', 'Withdrawals will be directed to the same source. If your query is not covered by the information contained here, please email') }}
                        <span v-if="$siteSettings?.data?.social_link?.email">
                            <a :href="'mailto:' + $siteSettings?.data?.social_link?.email" class="text-primary" style="text-decoration: underline;">
                                    {{ $siteSettings?.data?.social_link?.email }}
                                </a>
                        </span>
                        {{ $t('where-staff-will-be-on-hand', 'where staff will be on hand to answer your query.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <!--qrPreview Modal -->
     <div class="modal fade" id="qrPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="qrPreview-image">
                        <img loading="lazy" :src="currentImgLink" alt="asg_rouletted1-thumb">
                    </div>
                </div>
                <div class="searchbar-main deposit-page-close">
                    <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="qrShareModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="qrShare-list">
                        <li>
                            <a :href="`whatsapp://send?text=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/whatsapp-share-new.svg" alt="whatsapp-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/facebook-share-new.svg" alt="facebook-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://t.me/share/url?url=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/telegram-share-new.svg" alt="telegram-share.svg">
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" @click="$emit('copyImgUrl')" target="_blank">
                                <img loading="lazy" src="@/assets/images/instagram_new.webp" alt="facebook-share.svg">
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="searchbar-main deposit-page-close">
                    <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">{{$t('close','Close')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { useStore } from 'vuex'
import { createWorker } from 'tesseract.js';
import { ref, computed ,onMounted,inject, getCurrentInstance } from 'vue';
import { getParentPaymentsMethods, onUploadImage, submitDepositAmount, getPaymentGatewayUrl } from '../services/depositPayment';
import WalletHistory from '../components/WalletHistory.vue';
const { $t, $errorToast, $successToast, $siteSettings } = getCurrentInstance().proxy;

const store = useStore();

const walletConfig = inject('walletConfig')
// ref
const paymentMethods = ref(null);
const selectedPaymentMethod = ref(null);
const uploadedImage = ref(null);
const manual_utr = ref(null);
const fileRef = ref(undefined);
const has_edited_utr = ref(0);
const loading = ref(false);
const selectPaymentAccount = ref(null);
const previewImageUtr = ref(null);
const copiedText = ref(null);
const walletLoading = ref(false);
const currentImgLink = ref(null);
const t = ref(6);
const interval = ref(30);
const angle = ref(0);
const intervalCounter = ref(0);
const timerValue = ref(9);
const timer = ref(null);
const utrLoader = ref(false);
const utrerror = ref(false);
const init = ref({
    utr: false,
    transaction_image_url: false
});
const termsAgreed = ref(false);
const utrLimitError = ref(false);
const currentAccount = ref(-1);
const utrMsg = ref({
    langKey: 'enter-utr',
    msg: "Kindly enter UTR Number manually for fast deposit."
});
const tesseract_utr = ref(null);
const isPaymentGateway = ref(null);
const manualEnterUtr = ref(0);
const activeTab = ref(null);
const accountDetails = ref(null);
const paymentProofFileUploadStatus = ref('');
// template refs
const sbtBtn = ref(null);
// computed
const bonusData = computed(() => store.getters?.bonusData);
const depositAmount = computed(() => store.getters?.depositAmount);

const methodIcons = computed(() => {
    let iconObj = {};
    walletConfig?.value?.payment_method?.forEach(element => {
        iconObj[element.method_name] = element.icon
    });
    walletConfig?.value?.bank_list?.forEach(element => {
        iconObj[element.bank_name] = element.icon
    });
    return iconObj
});

const paymentBonus = computed(() => {
    if (!bonusData.value || !Array.isArray(bonusData.value)) {
        return {};
    }

    const paymentBonusData = bonusData.value?.filter(bd => bd.bonusType === 'payment bonus');

    if (paymentBonusData.length === 0) {
        return {};
    }

    return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
        try {
            const methodIds = JSON.parse(bonusElement.methodIds);
            if (Array.isArray(methodIds)) {
                methodIds?.forEach(methodId => {
                    methodBonusMap[methodId] = bonusElement.percentage;
                });
            }
        } catch (error) {
            console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
        }
        return methodBonusMap;
    }, {});
});
    // methods

    // function sanitizeInput() {
    //     manual_utr.value = manual_utr.value?.replace(/\D+/g, '');
    // };
        function clearPaymentSlip() {
            previewImageUtr.value = null;
            manual_utr.value = '';
            // file.value = undefined;
            termsAgreed.value = false;
            utrLimitError.value = '';
            loading.value = false;
            // utrerror.value = '';
            manualEnterUtr.value = 0;
        };
        function copyPaymentData(catagory, accountData) {
            if (!accountData) {
                $errorToast($t('no-data-available-to-copy', 'No Data Available To Copy.'));
                return;
            }
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            copiedText.value = accountData;
            $successToast(catagory + ' Copied Successfully');
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = '';
            });
            setTimeout(() => {
                copiedText.value = null;
                document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
                    el.style.color = '#0cddff';
                });
            }, 1000);
        };
         async function goToPaymentGateway() {
            try {
                const response = await getPaymentGatewayUrl(depositAmount.value, selectedPaymentMethod.value?.[0]?.master_account_id);
                console.log(response)
            } catch (error) {
                $errorToast(error)
            }
        };
        function changeAccount(account, index) {
            currentAccount.value = index
            accountDetails.value = account
            toggleInit(false)
        };
        function selectPaymentMethodAccount(paymentAccount) {
            selectPaymentAccount.value = paymentAccount;
        };
        async function getParentPaymentMethods(reconnectTry = 0) {
            try {
                let response = await getParentPaymentsMethods(reconnectTry, depositAmount.value);
                if (response?.data) {
                    paymentMethods.value = response?.data
                    let nonSocialStartIndex = response?.nonSocialStartIndex;
                    activeTab.value = Object.keys(paymentMethods.value)[nonSocialStartIndex]
                    choosePaymentMethod(paymentMethods.value[activeTab.value], activeTab.value);
                }
            } catch (error) {
                $errorToast(error)
            }
        };
        function choosePaymentMethod(payment, index) {
            clearPaymentSlip()
            toggleInit(false)
            activeTab.value = index
            selectedPaymentMethod.value = payment
            if (payment?.[0]?.method == 'social') {
                const socialNumber = payment?.[0]?.social_payment_number;
                const socialLink = payment?.[0]?.social_payment_link;
                if (socialNumber?.length && socialLink?.length) {
                    const choice = Math.random() < 0.5 ? 'number' : 'link';
                    if (choice === 'number') {
                        if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                            window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                        } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                            window.open(`https://t.me/${socialNumber}`, 'blank');
                        }
                    } else {
                        window.open(socialLink, 'blank');
                    }
                    return;
                }
                if (socialNumber?.length) {
                    if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                        window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                    } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                        window.open(`https://t.me/${socialNumber}`, 'blank');
                    }
                    return;
                }
                if (socialLink?.length) {
                    window.open(socialLink, 'blank');
                    return;
                }
                $errorToast($t('no-social-payment-number', 'No social payment number available'));
                return;
            };
            if (payment?.[0]?.method == 'payment_gateway') {
                isPaymentGateway.value = true;
                selectedPaymentMethod.value = payment;
                return
            }
            activeTab.value = index
            // currentPaymentId.value = payment?.[0]?.method
            selectedPaymentMethod.value = payment
            // AccountS3Url.value = payment?.qrCodeUrl
            accountDetails.value = selectedPaymentMethod.value?.[0]
            isPaymentGateway.value = false;
            selectPaymentAccount.value = selectedPaymentMethod.value?.[0]
        };
        function toggleInit(bool) {
            init.value = {
                utr: bool,
                transaction_image_url: bool
            }
        };
        async function walletDepositSubmitBtn() {
            try {
                termsAgreed.value = true;
                toggleInit(true);
                if(!uploadedImage.value) return ;
                if (accountDetails.value?.method != 'wallet' && (manual_utr.value?.length < 10 || !manual_utr.value)) return;
                await submitDepositAmount({
                    accountDetails: accountDetails.value,
                    uploadedImage: uploadedImage.value,
                    depositAmount: depositAmount.value,
                    manual_utr: manual_utr.value,
                    removeImage: removeImage,
                    has_edited_utr: has_edited_utr.value
                });

            } catch (error) {
                console.log(error);
                $errorToast(error)
            }
        };
        function removeImage() {
            uploadedImage.value = null
            previewImageUtr.value = null
            manual_utr.value = ''
            manualEnterUtr.value = 0
        };
        function validateUTR() {
            manual_utr.value = manual_utr.value?.replace(/[^0-9]/g, '').replace(/[+-]/g, '')
            if (manual_utr.value == null || manual_utr.value == '')
                utrerror.value = true;
            else if (manual_utr.value?.length < 10 || manual_utr.value?.length > 15)
                utrLimitError.value = true;
            else
                utrLimitError.value = false;
                utrerror.value = false;
        };
        async function fileUpdateFunc(event) {
        try {
            paymentProofFileUploadStatus.value = 'Fetching payment proof file';
            const file = event.target.files?.[0];
            // Only proceed if at least one file is selected
            if (!file) {
                return $errorToast($t('no-file-selected','No File selected to upload'))
            }
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
            const maxFileSize = 5 * 1024 * 1024; 
            if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
                $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
               previewImageUtr.value = null;
               fileRef.value.value = null
                return;
            }
            paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
            previewImageUtr.value = URL.createObjectURL(file)
            let response = await onUploadImage({
                event,
                depositAmount: depositAmount.value,
                startTimer: startTimer,
                resetTimer: resetTimer,
                sbtBtn: sbtBtn.value,
                paymentProofFileUploadStatus
            });
            if (response) {
                if(!response?.manual_utr){
                paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
                }else{
                    paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
                }
                manual_utr.value = response?.manual_utr;
                utrMsg.value = response?.utrMsg;
                uploadedImage.value = response?.uploadedImage;
                previewImageUtr.value = response?.previewImage;
                tesseract_utr.value = response?.tesseract_utr;
                utrLoader.value = false
                if (response.manual_utr) {
                    has_edited_utr.value = 0
                }
            }
            else {
                paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
                // this.previewImage = null
            }
        } catch (error) {
            console.log('error: ', error);
            previewImageUtr.value = null;
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            $errorToast(error)
        }
        finally{
            setTimeout(() => {
                paymentProofFileUploadStatus.value = '';
            }, 2000);
        }
    };
    function startTimer() {
        utrLoader.value = true;
        angle.value = 0;
        intervalCounter.value = 0;
        timerValue.value = t.value;

        if (timer.value) {
            clearInterval(timer.value);
        }

        timer.value = setInterval(() => {
            intervalCounter.value = intervalCounter.value + 1;
            angle.value = (intervalCounter.value / (t.value * (1000 / interval.value))) * 360;

            timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

            if (timerValue.value <= 0) {
                resetTimer();
                utrLoader.value = false;
            }
        }, interval.value);
    };
    function onFilePickerOpen() { 
        window.addEventListener('focus', () => {        
            setTimeout(() => {
                const files = fileRef.value?.files;
                if (files?.length == 0) {
                    $errorToast('File not selected. Check permission or try again!!')
                }
            }, 1000);
        }, { once: true })
    }
    function resetTimer() {
        clearInterval(timer.value);
        utrLoader.value = false;
        angle.value = 0;
        intervalCounter.value = 0;
        timerValue.value = t.value;
    };
    function downloadQrImg(imageUrl, name) {
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = name;
        link.target = '_blank';
        link.click();
    };
    const formatNumberToIntegerOrTwoDigitDecimal = (num) => {
        return (Number.isInteger(num) ? num : num?.toFixed(2)) ?? num;
    };
// hooks
onMounted(getParentPaymentMethods)        
</script>